import React, { useEffect, useState, useContext, useCallback } from 'react'
import styled from 'styled-components'
import { InfoWindow, OverlayView } from '@react-google-maps/api'
import TripsContext from '../../contexts/TripsContext'

type LatLng = {
    lat: any
    lng: any
}

type IProps = {
    position: LatLng
    icon?: string
    color?: string
    size1?: number
    size2?: number
    size3?: number
    backgroundOpacity?: number
    backgroundColor?: string
    borderColor?: string
    iconBackground?: string
    tooltipContent?: JSX.Element
    tooltipIsOpen?: boolean
    top?: number
    customIcon?: JSX.Element
    onMouseOver?(): void
    onMouseOut?(): void
}

const OverlayMarker = ({
    position,
    icon,
    color,
    size1,
    size2,
    size3,
    borderColor,
    iconBackground,
    backgroundColor,
    backgroundOpacity,
    tooltipContent,
    tooltipIsOpen = true,
    top = 0,
    customIcon,
    onMouseOver,
    onMouseOut
}: IProps): JSX.Element => {
    const ContainerIconsDefault = () => {
        return (
            <ContainerIcons>
                <Icon size={`${size1 || '28'}`} color={`${borderColor || 'gray-0'}`}>
                    <i className={`${iconBackground || 'fas fa-map-marker'}`}></i>
                </Icon>

                <Icon
                    opacity={backgroundOpacity || 1}
                    size={`${size2 || '25'}`}
                    color={`${backgroundColor || 'blue-500'}`}
                >
                    <i className={`${iconBackground || 'fas fa-map-marker'}`}></i>
                </Icon>
                <Icon size={`${size3 || '13'}`} color={`${color || 'gray-0'}`}>
                    <i className={icon}></i>
                </Icon>
            </ContainerIcons>
        )
    }

    return (
        <>
            {position && (
                <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                    <ContainerOverlay
                        style={{ top: top }}
                        onMouseEnter={e => onMouseOver()}
                        onMouseLeave={e => onMouseOut()}
                    >
                        {customIcon || <ContainerIconsDefault />}

                        {tooltipContent && tooltipIsOpen && (
                            <ContainerTooltip>
                                <Tooltip>{tooltipContent}</Tooltip>
                            </ContainerTooltip>
                        )}
                    </ContainerOverlay>
                </OverlayView>
            )}
        </>
    )
}

export default React.memo(OverlayMarker)

const ContainerOverlay = styled.div`
    position: absolute;
`

const ContainerTooltip = styled.div`
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    top: -12px;
    height: 20px;
    z-index: -1;
    left: 0px;
    padding: 4px 6px 4px 14px;
`

const ContainerIcons = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Icon = styled.div`
    opacity: ${({ opacity }) => opacity};
    position: absolute;
    font-size: ${({ size }) => `${size}px`};
    color: ${({ theme, color }) => (theme[color] ? theme[color] : color)};
`

const Tooltip = styled.div`
    color: #7b61ff;
    font-weight: 600;
    font-size: 11px;
    white-space: nowrap;
`
